<template>
  <div>
    <!-- <h3 class="text-center text-space">{{ translatedFields['result'] }}</h3> -->
    <p class="result"  v-html="result"> </p>
  </div>
</template>

<script>

export default {
  props: {
    result: String
  },
  data () {
    return {
      fields_en: {
        result: 'Result'
      }
    }
  }
}
</script>

<style scoped>
.result{
  text-align: center;
  font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/Result.vue